function Niger({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1780)">
  <path d="M1.58763 9.04366C0.5705 11.1472 0 13.507 0 16.0002C0 18.4933 0.5705 20.8532 1.58763 22.9567L16 24.348L30.4124 22.9567C31.4295 20.8532 32 18.4933 32 16.0002C32 13.507 31.4295 11.1472 30.4124 9.04366L16 7.65234L1.58763 9.04366Z" fill="#F0F0F0"/>
  <path d="M1.58813 22.9561C4.17601 28.308 9.65657 31.9996 15.9999 31.9996C22.3433 31.9996 27.8239 28.308 30.4117 22.9561H1.58813Z" fill="#6DA544"/>
  <path d="M1.58813 9.0435H30.4117C27.8239 3.69156 22.3433 0 15.9999 0C9.65663 0 4.17601 3.69156 1.58813 9.0435Z" fill="#FF9811"/>
  <path d="M16 21.5649C19.0736 21.5649 21.5652 19.0733 21.5652 15.9998C21.5652 12.9262 19.0736 10.4346 16 10.4346C12.9264 10.4346 10.4348 12.9262 10.4348 15.9998C10.4348 19.0733 12.9264 21.5649 16 21.5649Z" fill="#FF9811"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Niger;
